/**
 * Plan cart utility functions
 *
 * @internal This module is for internal use within the core module only.
 * Do not import directly from outside the core folder.
 */
import Cookies from 'js-cookie';

export const getCurrency = () => {
  const currency = Cookies.get('_zm_currency');
  return currency || 'USD';
};

export const isJestTest = () => {
  return (
    process.env.NODE_ENV === 'test' ||
    typeof jest !== 'undefined' ||
    typeof describe !== 'undefined' ||
    typeof it !== 'undefined' ||
    typeof expect !== 'undefined' ||
    !!process.env.JEST_WORKER_ID
  );
};

export const safeJSONParse = (jsonString, defaultValue = null) => {
  let json = defaultValue;
  try {
    json = JSON.parse(jsonString);
  } catch (e) {
    console.error(e);
  }
  return json;
};
